import { matchRoutes, useLocation, useOutletContext } from 'react-router-dom';
import { connect } from 'react-redux';
import get from 'lodash/get';

import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';

// import { routePaths } from '../utils/route-paths';

import { ReactComponent as EditIcon } from '../assets/icons/main/create-icon.svg';
import { useTheme } from '@mui/material';

interface EditButtonWithAccessCheckPropTypes {
  userAccess: any;
  onClick: () => void;
  styles?: object;
  otherProps?: any;
}

const ontologyManagementStyles = {
  tooltipTitle: { fontSize: '1rem' },
  // tooltipComponentProps: {
  //   tooltip: {
  //     sx: {
  //       padding: '4px 16px',
  //       backgroundColor: '#51648F',
  //       color: '#fff',
  //       display: 'flex',
  //       alignItems: 'center',
  //       justifyContent: 'center',
  //     },
  //   },
  // },
};

const EditButtonWithAccessCheck = ({
  userAccess,
  onClick,
  styles = {},
  otherProps = {},
}: EditButtonWithAccessCheckPropTypes) => {
   const routePaths: any = get(useOutletContext(), 'combinedRoutePaths', [])
  const { pathname } = useLocation();
  const matchedRoute = matchRoutes(routePaths, pathname);
  const hasNoAccessToCreate = !get(userAccess, `${get(matchedRoute, '[0].route.endPointPath', '')}.update`, false);
  const theme :any = useTheme();
  return (
    <Tooltip
      title={
        <Typography variant='subtitle1' sx={ontologyManagementStyles.tooltipTitle}>
          Edit {otherProps.levelName}
        </Typography>
      }
      placement={otherProps.toolTipPlacement || 'top'}
      arrow      
    >
      <IconButton onClick={onClick} disabled={hasNoAccessToCreate} style={{padding: 0}}>
        <EditIcon style={{color:theme.palette.custom.light, opacity: hasNoAccessToCreate ? 0.5 : 1 }} />
      </IconButton>
    </Tooltip>
  );
};

const mapStateToProps = (state: any) => ({
  userAccess: state.profile.userAccess,
});

export default connect(mapStateToProps)(EditButtonWithAccessCheck);
